import './TableEmptyState.scss';

export default function TableEmptyState({ text = 'No items' }) {
  return (
    <div className="table-empty-state">
      <p>{text}</p>
    </div>
  );
}
